import { render, staticRenderFns } from "./PrivacyUserList.vue?vue&type=template&id=45bf6415&"
import script from "./PrivacyUserList.vue?vue&type=script&lang=js&"
export * from "./PrivacyUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports